import React from "react";
import PropTypes from "prop-types";
import { Button, PopOver } from "@cgn/framework-ui-components/v1";
import { PrinterIcon } from "@cgn/framework-ui-components/icons";

const CampoAux = ({ etichetta, valore }) => {
  if (!etichetta) return null;
  return (
    <React.Fragment>
      &nbsp; | &nbsp;
      <strong>{etichetta}:</strong> {valore}
    </React.Fragment>
  );
};

CampoAux.propTypes = {
  etichetta: PropTypes.string,
  valore: PropTypes.string,
};

CampoAux.defaultProps = {
  etichetta: undefined,
  valore: undefined,
};

/**
 */
const Intestazione = ({ pratica, disabilitaStampa, onStampa }) => (
  <div className="quesito__intestazione">
    <div>
      <strong>Servizio:</strong> {pratica.Servizio}&nbsp; | &nbsp;
      <strong>Categoria:</strong> {pratica.Categoria}
      <CampoAux
        etichetta={pratica.EtichettaCampoAux1}
        valore={pratica.CampoAux1}
      />
      <CampoAux
        etichetta={pratica.EtichettaCampoAux2}
        valore={pratica.CampoAux2}
      />
    </div>
    {!disabilitaStampa && (
      <div className="pull-right">
        <PopOver bottom content="Stampa">
          <Button floating onClick={onStampa} className="quesito__btnStampa">
            <PrinterIcon />
          </Button>
        </PopOver>
      </div>
    )}
  </div>
);

Intestazione.propTypes = {
  pratica: PropTypes.shape({
    Servizio: PropTypes.string,
    Categoria: PropTypes.string,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
    CampoAux1: PropTypes.string,
    CampoAux2: PropTypes.string,
  }).isRequired,
  onStampa: PropTypes.func.isRequired,
  disabilitaStampa: PropTypes.bool.isRequired,
};

Intestazione.defaultProps = {};

export default Intestazione;
